import { ScheduleSpeakingClassesEvent } from "@/types";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { useRef, useState } from "react";
import Confirmation from "./DesktopConfirmation";
import SelectLesson from "./SelectLesson";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

 
const Content = ({ onClose }: { onClose?: () => void }) => {

  const [step, setStep] = useState(0);
  const details = useRef<ScheduleSpeakingClassesEvent[] | null>(null);

  return step == 0 ? (
    <SelectLesson onConfirm={(eventDetails) => { 
        setStep(1); 
        details.current = eventDetails ?? null;
      }}
      onClose={onClose}
    />
  ) : (
    <Confirmation events={details.current as never} onClose={onClose} />
  );
};

export default Content;
// export default React.memo(Content);
